module.exports = __webpack_public_path__ + "ee64eaf91f14478b29cd097c133c564a.svg";